import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import useRolePermission from "entities/auth/hooks/useRolePermission";
import React, { FC } from "react";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { AddCircleIcon } from "shared/theme/icons/AddCircleIcon";
import { StyledNoOptionContainer, StyledLoadingContainer } from "./styled";

type Props = {
  loading: boolean;
  inputValue?: string;
  onClick: () => void;
};

const EmptyOptions: FC<Props> = (props) => {
  const writeAccess = useRolePermission("tags:write");

  if (!writeAccess.allowed) {
    return (
      <StyledNoOptionContainer>
        <Typography
          fontWeight="600"
          variant="bodyMMedium"
          color={COLOR_PRIMARY_MAIN}
          data-testid={`new-tag-type-${props.inputValue}`}
        >
          No tag type found
        </Typography>
      </StyledNoOptionContainer>
    );
  }

  return (
    <StyledNoOptionContainer onClick={props.onClick}>
      <Typography
        fontWeight="600"
        variant="bodyMMedium"
        color={COLOR_PRIMARY_MAIN}
        data-testid={`new-tag-type-${props.inputValue}`}
      >
        {props.inputValue}
      </Typography>

      {props.loading && (
        <StyledLoadingContainer>
          <CircularProgress className="loading" size={20} thickness={5} />
        </StyledLoadingContainer>
      )}

      {!props.loading && (
        <Box display="flex" alignItems="center" data-testid="add-new-tag-type">
          <AddCircleIcon />
          <Typography
            color={COLOR_PRIMARY_MAIN}
            variant="bodyMMedium"
            ml="10px"
            fontWeight="600"
          >
            Add New Primary Tag
          </Typography>
        </Box>
      )}
    </StyledNoOptionContainer>
  );
};

export default EmptyOptions;
